/**
 * Created by akrio on 2018/3/23.
 */
/**
 * 通用相关
 */
export const MENU_OPEN = "MENU_OPEN"; // 菜单是否打开
export const LOCATION = "LOCATION"; // 菜单是否打开
export const LANGUAGE = "LANGUAGE"; // 语言
export const TIMEZONE = "TIMEZONE"; // 时区
export const ACCOUNT_BACK = "ACCOUNT_BACK"; // account页面返回信息
export const FIRST_DRAG = "FIRST_DRAG"; // 是否第一次进入drag
export const VALIDATE_INFO = "VALIDATE_INFO"; // 验证保存的
/**
 * 用户信息相关
 */
export const USER_TOKEN = "USER_TOKEN"; // 登录token
export const CURRENT_USER_INFO = "CURRENT_USER_INFO"; // 当前登录人信息
export const CURRENT_PUBLISHER_ID = "CURRENT_PUBLISHER_ID"; // 当前查询publisher的id
export const CURRENT_USER_INFO_SIMPLE = "CURRENT_USER_INFO_SIMPLE"; // 对当前登录人信息进行二次封装
export const CURRENT_PUBLISHER_SIMPLE = "CURRENT_PUBLISHER_SIMPLE"; // 对当前选中publisher信息进行二次封装
export const PUBLISHER_CAPTION_COMMENT_LIST = "PUBLISHER_CAPTION_COMMENT_LIST"; // 保存当前所有publisher COMMENT CAPTION
export const CURRENT_PUBLISHER_CAPTION_COMMENT_SIMPLE =
  "CURRENT_PUBLISHER_CAPTION_COMMENT_SIMPLE"; // 获取当前选中的publisher comment和caption
/**
 * media
 */
export const MEDIA_LIBRARY_LIST = "MEDIA_LIBRARY_LIST"; // media library 图片数组
export const MEDIA_LIBRARY_PARAMS = "MEDIA_LIBRARY_PARAMS"; // media library 索引条件
export const SAVED_LIBRARY_LIST = "SAVED_LIBRARY_LIST"; // saved library 图片数组
export const SAVED_LIBRARY_PARAMS = "SAVED_LIBRARY_PARAMS"; // saved library 索引条件
/**
 * plan
 */
export const CURRENT_USER_PLAN_LIST = "CURRENT_USER_PLAN_LIST"; // 当前登录用户plan计划
export const CURRENT_USER_PLAN_LIST_SIMPLE = "CURRENT_USER_PLAN_LIST_SIMPLE"; // 封装后的当前登录用户plan计划
/**
 * payment
 */
export const PAYMENT_INFO = "PAYMENT_INFO"; // 保存的支付信息
/**
 * d&d
 */
export const DRAG_DROP_PUBLISHER_LIST = "DRAG_DROP_PUBLISHER_LIST"; // d&d 每个publisher对应信息
export default [
  DRAG_DROP_PUBLISHER_LIST,
  CURRENT_USER_PLAN_LIST,
  USER_TOKEN,
  CURRENT_USER_INFO,
  MEDIA_LIBRARY_LIST,
  MEDIA_LIBRARY_PARAMS,
  LOCATION,
];
/**
 * repost
 */
export const REPOST_HISTORY = "REPOST_HISTORY"; // repost 的历史记录
// bulk
export const BULK_DEFAULT_INFO = "BULK_DEFAULT_INFO"; // bulk 关于default开关的配置 基于publisher
